<template>
    <div class="guide-filter">
        <div class="guide-filter__container">
            <filter-tabs ref="btnFilter"/>
        </div>
        <div class="guide-filter__time">{{ currentTimeStr }}</div>
    </div>
</template>

<script setup lang="ts">
    import { computed, type Ref, ref } from "vue";
    import { useApplicationStore } from "@/stores/Application";
    import { TimeUtils } from "@/utils";
    import { useI18n } from "vue-i18n";
    import { storeToRefs } from 'pinia';
    import type { IGuideFilterExposed } from "./types";
    import { type FilterTabsRef } from "../FilterTabs/types";

    const ApplicationStore = useApplicationStore();
    const {
        getCurrentTime: currentTime,
    } = storeToRefs(ApplicationStore);

    const { isTimeFormat12 } = useAppConfig();
    const { locale } = useI18n();
    const btnFilter: Ref<FilterTabsRef | null> = ref(null);

    const currentTimeStr = computed((): string => {
        const timeFormat = isTimeFormat12 ? 'hh:mm a' : 'HH:mm';
        return TimeUtils.getMoment(locale.value, currentTime.value).format(timeFormat).toUpperCase();
    });

    const focusToFilterTabs = () => {
        btnFilter.value?.focusDefault();
    };

    defineExpose<IGuideFilterExposed>({
        focusToFilterTabs
    });
</script>

<style lang="scss">
    @import url("styles.scss");
</style>